import { useState } from 'react';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { CustomizedTypography } from '@components/Customized';
import useStyles from './useStyles';

const PrintingTooltip = () => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  return (
    <div className={classes['printing-tooltip']}>
      <Tooltip
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onClick={() => {
          setOpen(true);
        }}
        classes={{ tooltip: classes['tooltip-paper'] }}
        title={
          <div>
            <CustomizedTypography
              variant="body2"
              color="textPrimary"
              fontWeight="500"
              gutterBottoms={8}
            >
              지원하는 모든 확장자
            </CustomizedTypography>
            <CustomizedTypography
              variant="body2"
              color="textSecondary"
              fontWeight="500"
            >
              .OBJ, .SKP, .STL, .SAT, .SAB, .IPT, .MODEL, .SESSION, .DLV, .EXP,
              .CATPart, .CGR, .DAE, .NEU, .PRT, .XPR, .FBX, .GLTF, .GLB, .IFC,
              .IGS, .IGES, .JT, .X_B, .X_T, .RVT, .3DM, .PAR, .PSM, .SLDPRT,
              .STP, .STEP
            </CustomizedTypography>
          </div>
        }
      >
        <div className={'tooltip-text'}>
          <Info fontSize="small" color="primary" />
          <CustomizedTypography
            color="primary"
            variant="body2"
            fontWeight="500"
          >
            지원하는 파일 확장자
          </CustomizedTypography>
        </div>
      </Tooltip>
    </div>
  );
};

export default PrintingTooltip;
